import Decimal from "decimal.js";
import { WorksheetCostRowInput } from "DDD/action-objects/WorksheetItemUpdate";
import {
  WorksheetCostCategory,
  WorksheetHeaderUnit,
  WorksheetMaterialCalcMethod,
} from "generated/graphql";
import { computeMaterialQuantity } from "./worksheetMath";
import { parseDecimalInput } from "./worksheetNumbers";

export const getMaterialRowQuantity = (
  row: WorksheetCostRowInput,
  lineQuantity: string,
  lineUnit: WorksheetHeaderUnit
): Decimal => {
  if (
    row.category === WorksheetCostCategory.MATERIAL &&
    row.calcMethod !== WorksheetMaterialCalcMethod.MANUAL &&
    !row.quantityOverridden
  ) {
    const computed = computeMaterialQuantity({
      calcMethod: row.calcMethod,
      jobSize:
        row.jobSizeOverride !== ""
          ? parseDecimalInput(row.jobSizeOverride)
          : parseDecimalInput(lineQuantity),
      jobSizeUnit: (row.jobSizeUnit || lineUnit) as WorksheetHeaderUnit,
      coverageRate: parseDecimalInput(row.coverageRate),
      coverageUnit: row.coverageUnit,
      thickness: parseDecimalInput(row.thickness),
      thicknessUnit: row.thicknessUnit,
      density: parseDecimalInput(row.density),
      densityUnit: row.densityUnit,
      weightFactor: parseDecimalInput(row.weightFactor),
      outputUnit: row.outputUnit,
    });

    if (computed !== null) {
      return new Decimal(computed);
    }
  }

  try {
    return new Decimal(row.quantity || 0);
  } catch {
    return new Decimal(0);
  }
};
